import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const MultipleSelectComponent = ({
  name,
  label,
  items,
  value,
  change,
  gridColumn,
  gridRow,
  error,
  touched,
  required,
}) => {
  const { t } = useTranslation();
  return (
    <FormControl
      variant="filled"
      fullWidth
      sx={{ gridColumn: gridColumn, gridRow: gridRow }}
    >
      <InputLabel id={name} required={required}>{t("fields.selectMany", { label })}</InputLabel>
      <Select
        name={name}
        labelId={name}
        id={name}
        value={value}
        multiple
        label={label}
        onChange={change}
        sx={{ gridColumn: gridColumn, gridRow: gridRow }}
        error={!!touched && !!error}
      >
        {items.map((item) => (
          <MenuItem
            key={item._id}
            value={item._id}
            sx={{
              opacity: value.includes(item._id) ? 1 : 0.6,
              backgroundColor: value.includes(item._id)
                ? "black !important"
                : "transparent",
              color: value.includes(item._id) ? "white" : "inherit",
            }}
          >
            {item.labelKey ? t(item.labelKey) : item.name}
          </MenuItem>
        ))}
      </Select>
      {touched && error && (
        <FormHelperText sx={{ color: "error.main" }}>{error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default MultipleSelectComponent;
